import { z } from "zod";

import { entitySchema } from "@/common/schema/entity";
import { CropUnit } from "@/generated/digitalnisklady.cz/graphql";

const traderSchema = entitySchema.extend(
  z.object({
    logo: z.url(),
    tocUrl: z.string().nullable().optional(),
  }).shape,
);

const cropUnitSchema = z.enum(CropUnit);

export { cropUnitSchema, traderSchema };
